import { client } from '@repo/sdk'

import { logger } from './logger'
import { setupTokenInterceptor } from './tokenInterceptor'
import { getApiUrl } from './runtime-env'

// NOTE: no QueryClient is created here. <Refine> builds and provides its own, so the one that
// used to live in this file was never mounted and its staleTime/retry options never applied.
// Query defaults belong in <Refine options={{ reactQuery: { clientConfig } }}> if we ever need them.

/**
 * Response contracts this bundle's screens understand (#72). Sent on every request — setConfig
 * replaces headers, so both configure calls below include it.
 */
const CLIENT_CONTRACT_HEADERS = {
  'X-Client-Contracts': 'shipping-charge-v1',
  // The dealer backoffice calls the app's own routes; the server files its work under the dealer
  // backoffice channel in the dealer history by this header (#273).
  'X-Client-App': 'dealer-backoffice',
}

export function initApiClient(): void {
  const apiUrl = getApiUrl()

  try {
    client.setConfig({
      baseUrl: apiUrl,
      throwOnError: true,
      headers: {
        'Content-Type': 'application/json',
        ...CLIENT_CONTRACT_HEADERS,
      },
    })

    setupTokenInterceptor(client)
    logger.info('[API] Client configured with base URL:', apiUrl)
  } catch (error_) {
    logger.error('[API] Failed to configure client:', error_)
  }
}

export function setAuthToken(token: string | null): void {
  try {
    client.setConfig({
      throwOnError: true,
      headers: {
        'Content-Type': 'application/json',
        ...CLIENT_CONTRACT_HEADERS,
        Authorization: token ? `Bearer ${token}` : null,
      },
    })

    logger.info('[API] Auth token', token ? 'set' : 'cleared')
  } catch (error_) {
    logger.error('[API] Failed to set auth token:', error_)
  }
}

initApiClient()
